// Little Ivory — theme JS (drawers, mobile nav, wishlist, quick add, misc)
(function () {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  // Drawer open/close
  window.LI = window.LI || {};
  window.LI.openDrawer = (id) => {
    const d = document.getElementById(id);
    if (!d) return;
    d.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    d.querySelector('[data-drawer-close]')?.focus();
  };
  window.LI.closeDrawer = (id) => {
    const d = document.getElementById(id);
    if (!d) return;
    d.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  };

  document.addEventListener('click', (e) => {
    const open = e.target.closest('[data-drawer-open]');
    if (open) { e.preventDefault(); window.LI.openDrawer(open.getAttribute('data-drawer-open')); }
    const close = e.target.closest('[data-drawer-close]');
    if (close) { const d = close.closest('.drawer'); if (d) window.LI.closeDrawer(d.id); }
    const scrim = e.target.closest('.drawer__scrim');
    if (scrim) { const d = scrim.closest('.drawer'); if (d) window.LI.closeDrawer(d.id); }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') $$('.drawer[aria-hidden="false"]').forEach((d) => window.LI.closeDrawer(d.id));
  });

  // Wishlist (localStorage)
  const WK = 'li-wishlist';
  const readW = () => { try { return JSON.parse(localStorage.getItem(WK) || '[]'); } catch { return []; } };
  const writeW = (v) => localStorage.setItem(WK, JSON.stringify(v));
  window.LI.wishlist = {
    has: (id) => readW().includes(String(id)),
    toggle: (id) => {
      const list = readW(); const s = String(id); const i = list.indexOf(s);
      if (i >= 0) list.splice(i, 1); else list.push(s);
      writeW(list); paintW();
      document.dispatchEvent(new CustomEvent('li:wishlist-change', { detail: list }));
    },
    list: readW,
  };
  function paintW() {
    const set = new Set(readW());
    $$('[data-wishlist-toggle]').forEach((btn) => {
      const id = btn.getAttribute('data-wishlist-toggle');
      btn.classList.toggle('is-active', set.has(String(id)));
      btn.setAttribute('aria-pressed', set.has(String(id)) ? 'true' : 'false');
    });
    const badge = $('#wishlist-count');
    if (badge) { const n = set.size; badge.textContent = n; badge.style.display = n ? '' : 'none'; }
  }
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-wishlist-toggle]');
    if (!b) return;
    e.preventDefault();
    window.LI.wishlist.toggle(b.getAttribute('data-wishlist-toggle'));
  });
  document.addEventListener('DOMContentLoaded', paintW);
  document.addEventListener('li:wishlist-change', paintW);
  paintW();
  window.LI.paintWishlist = paintW;

  // Thumbnail gallery
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-thumb]');
    if (!t) return;
    const wrap = t.closest('[data-gallery]');
    if (!wrap) return;
    const src = t.getAttribute('data-thumb');
    const main = wrap.querySelector('[data-main-image]');
    if (main) main.src = src;
    wrap.querySelectorAll('[data-thumb]').forEach((x) => x.classList.toggle('is-active', x === t));
  });

  // Toast
  window.LI.toast = (msg) => {
    let host = document.querySelector('.li-toasts');
    if (!host) { host = document.createElement('div'); host.className = 'li-toasts'; document.body.appendChild(host); }
    const t = document.createElement('div');
    t.className = 'li-toast'; t.setAttribute('role', 'status'); t.textContent = msg;
    host.appendChild(t);
    requestAnimationFrame(() => t.classList.add('is-in'));
    setTimeout(() => { t.classList.remove('is-in'); setTimeout(() => t.remove(), 300); }, 2600);
  };

  // Quantity steppers (respects max / stock)
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-qty]');
    if (!b) return;
    const dir = parseInt(b.getAttribute('data-qty'), 10);
    const input = b.parentElement.querySelector('input[name="quantity"]');
    if (!input) return;
    const cur = parseInt(input.value, 10) || 1;
    const max = parseInt(input.getAttribute('max'), 10);
    let v = cur + dir;
    if (dir > 0 && !isNaN(max) && cur >= max) {
      window.LI.toast(max > 0 ? `Only ${max} left in stock` : 'This item is out of stock');
      return;
    }
    v = Math.max(1, v);
    if (!isNaN(max)) v = Math.min(v, Math.max(1, max));
    input.value = v; input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // Manual typing guard on quantity
  document.addEventListener('change', (e) => {
    const input = e.target.closest('input[name="quantity"]');
    if (!input) return;
    const max = parseInt(input.getAttribute('max'), 10);
    let v = Math.max(1, parseInt(input.value, 10) || 1);
    if (!isNaN(max) && v > max) { v = Math.max(1, max); window.LI.toast(`Only ${max} left in stock`); }
    input.value = v;
  });

  // Sort dropdown auto-submit
  $$('[data-sort]').forEach((s) => s.addEventListener('change', () => {
    const u = new URL(window.location.href);
    u.searchParams.set('sort_by', s.value);
    window.location.href = u.toString();
  }));

  // Recently viewed
  const RK = 'li-recent';
  window.LI.pushRecent = (handle) => {
    if (!handle) return;
    try {
      const list = JSON.parse(localStorage.getItem(RK) || '[]').filter((h) => h !== handle);
      list.unshift(handle);
      localStorage.setItem(RK, JSON.stringify(list.slice(0, 8)));
    } catch {}
  };
  window.LI.recent = () => { try { return JSON.parse(localStorage.getItem(RK) || '[]'); } catch { return []; } };
})();

// --- Variant option syncing on PDP ---
(function(){
  const form = document.getElementById('product-form');
  if(!form) return;
  const select = form.querySelector('[data-variant-select]');
  const dataEl = document.querySelector('[data-product-json]');
  if(!select || !dataEl) return;
  let product; try { product = JSON.parse(dataEl.textContent); } catch { return; }
  let inventory = {};
  const invEl = document.querySelector('[data-variant-inventory]');
  if (invEl) { try { inventory = JSON.parse(invEl.textContent); } catch { inventory = {}; } }
  const btn = form.querySelector('[data-add-to-cart]');
  const label = form.querySelector('[data-add-label]');
  const infoWrap = form.closest('.pdp-info') || document;
  // Target only the visible price. Variant <option> elements also carry a
  // data-price attribute, so a broad [data-price] selector updates the hidden
  // option instead of the price displayed to the customer.
  const priceEl = infoWrap.querySelector('.pdp-price [data-current-price]') || infoWrap.querySelector('.pdp-price .price') || document.querySelector('.pdp-price [data-current-price]') || document.querySelector('.pdp-price .price');
  const compareEl = infoWrap.querySelector('[data-compare-price]') || document.querySelector('.pdp-price [data-compare-price]');
  const saveEl = infoWrap.querySelector('[data-save-note]') || document.querySelector('[data-save-note]');
  const saleBadge = document.querySelector('[data-sale-badge]');
  // Prefer Shopify's own money formatting (baked into the variant <option> data attrs)
  const moneyFromOption = (variantId, attr) => {
    const opt = select && select.querySelector('option[value="' + variantId + '"]');
    const v = opt && opt.getAttribute(attr);
    if (!v || !v.trim()) return null;
    // Currency-conversion apps can make Shopify's money filter return markup
    // such as <span class="money">₹ 1,299.00</span>. Convert that safely to
    // display text before assigning it to the visible price node.
    const parser = document.createElement('div');
    parser.innerHTML = v;
    return (parser.textContent || '').trim() || null;
  };
  const fmtFallback = (cents) => (cents/100).toLocaleString(undefined,{style:'currency',currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'});
  const fmtMoney = (cents, variantId, attr) => moneyFromOption(variantId, attr) || fmtFallback(cents);
  const inputs = form.querySelectorAll('input[type="radio"][name^="options["]');
  const qtyInput = form.querySelector('input[name="quantity"]');
  const stockNote = form.querySelector('[data-stock-note]');
  const gallery = document.querySelector('[data-gallery]');
  const mainImage = gallery && gallery.querySelector('[data-main-image]');

  // Show the image attached to the selected variant
  const syncImage = (variant) => {
    if (!mainImage || !variant) return;
    const media = variant.featured_media || variant.featured_image;
    if (!media) return;
    const mediaId = variant.featured_media ? variant.featured_media.id : null;
    let thumb = null;
    if (mediaId != null && gallery) {
      thumb = gallery.querySelector('[data-media-id="' + mediaId + '"][data-thumb]');
    }
    const src = thumb ? thumb.getAttribute('data-thumb') : (media.src || '').replace(/(\.[a-zA-Z]+)(\?|$)/, '$1?width=1200');
    if (src) mainImage.src = src;
    if (mediaId != null) mainImage.setAttribute('data-media-id', String(mediaId));
    if (gallery) {
      gallery.querySelectorAll('[data-thumb]').forEach((x) => x.classList.toggle('is-active', thumb ? x === thumb : false));
    }
  };

  const chosenValues = () => {
    const chosen = {};
    inputs.forEach(i => { if(i.checked) chosen[i.name.match(/\[(.+)\]/)[1]] = i.value; });
    return chosen;
  };

  // Disable option values that have no available variant for the current selection
  const refreshAvailability = () => {
    const optNames = product.options;
    const chosen = chosenValues();
    inputs.forEach((input) => {
      const name = input.name.match(/\[(.+)\]/)[1];
      const idx = optNames.indexOf(name);
      if (idx < 0) return;
      const exists = product.variants.some(v => {
        if (!v.available) return false;
        if (v.options[idx] !== input.value) return false;
        for (let i2 = 0; i2 < optNames.length; i2++) {
          if (i2 === idx) continue;
          const other = optNames[i2];
          if (chosen[other] !== undefined && chosen[other] !== v.options[i2]) return false;
        }
        return true;
      });
      const lbl = input.closest('.pdp-swatch');
      input.disabled = !exists;
      if (lbl) lbl.classList.toggle('is-unavailable', !exists);
    });
  };

  const sync = (evt) => {
    const chosen = chosenValues();
    const optNames = product.options;
    let match = product.variants.find(v => v.available && optNames.every((n,idx) => (chosen[n] ?? v.options[idx]) === v.options[idx]))
      || product.variants.find(v => optNames.every((n,idx) => (chosen[n] ?? v.options[idx]) === v.options[idx]));
    // If the new selection has no available combination, snap the other options
    // to the first available variant that keeps the just-changed value.
    if ((!match || !match.available) && evt && evt.target) {
      const changedName = evt.target.name.match(/\[(.+)\]/)?.[1];
      const changedIdx = changedName ? optNames.indexOf(changedName) : -1;
      if (changedIdx >= 0) {
        const fallback = product.variants.find(v => v.available && v.options[changedIdx] === evt.target.value);
        if (fallback) {
          inputs.forEach((i) => {
            const n = i.name.match(/\[(.+)\]/)?.[1];
            const ix = n ? optNames.indexOf(n) : -1;
            if (ix >= 0) i.checked = fallback.options[ix] === i.value;
          });
          match = fallback;
        }
      }
    }
    refreshAvailability();
    if(!match) return;
    select.value = match.id;
    syncImage(match);
    const url = new URL(location.href); url.searchParams.set('variant', match.id);
    history.replaceState({}, '', url);
    if(btn){ btn.disabled = !match.available; }
    if(label){ label.textContent = match.available ? 'Add to bag' : 'Sold out'; }
    if(priceEl && match.price != null){
      priceEl.textContent = fmtMoney(match.price, match.id, 'data-price');
    }
    // Sale price state for the selected variant
    const onSale = match.compare_at_price != null && match.compare_at_price > match.price;
    if (priceEl) priceEl.classList.toggle('price--sale', !!onSale);
    if (compareEl) {
      if (onSale) { compareEl.hidden = false; compareEl.removeAttribute('hidden'); compareEl.textContent = fmtMoney(match.compare_at_price, match.id, 'data-compare'); }
      else { compareEl.hidden = true; compareEl.textContent = ''; }
    }
    if (saveEl) {
      if (onSale) { saveEl.hidden = false; saveEl.removeAttribute('hidden'); saveEl.textContent = `Save ${fmtFallback(match.compare_at_price - match.price)}`; }
      else { saveEl.hidden = true; saveEl.textContent = ''; }
    }
    if (saleBadge) {
      const off = onSale ? Math.round((match.compare_at_price - match.price) * 100 / match.compare_at_price) : 0;
      saleBadge.hidden = !onSale;
      if (onSale) saleBadge.textContent = off > 0 ? `Sale −${off}%` : 'Sale';
    }
    // Stock cap
    const inv = inventory[String(match.id)];
    if (qtyInput) {
      if (inv && inv.m && inv.p === 'deny') {
        const max = Math.max(0, inv.q);
        qtyInput.setAttribute('max', String(max));
        if ((parseInt(qtyInput.value, 10) || 1) > max) qtyInput.value = String(Math.max(1, max));
        if (stockNote) {
          if (max > 0 && max <= 5) { stockNote.hidden = false; stockNote.textContent = `Only ${max} left in stock`; }
          else { stockNote.hidden = true; stockNote.textContent = ''; }
        }
      } else {
        qtyInput.removeAttribute('max');
        if (stockNote) { stockNote.hidden = true; stockNote.textContent = ''; }
      }
    }
  };
  inputs.forEach(i => i.addEventListener('change', sync));
  // Delegated fallback: catches clicks on swatch labels / dynamically re-rendered inputs
  form.addEventListener('change', (e) => {
    const t = e.target;
    if (t && t.matches && t.matches('input[type="radio"][name^="options["]')) sync(e);
  });
  form.addEventListener('click', (e) => {
    const lbl = e.target.closest && e.target.closest('.pdp-swatch');
    if (lbl) setTimeout(() => sync({ target: lbl.querySelector('input') }), 0);
  });
  sync();

  // Size guide modal
  const modal = document.querySelector('[data-size-guide]');
  if (modal) {
    const open = () => { modal.hidden = false; document.body.style.overflow = 'hidden'; };
    const close = () => { modal.hidden = true; document.body.style.overflow = ''; };
    document.addEventListener('click', (e) => {
      if (e.target.closest('[data-size-guide-open]')) { e.preventDefault(); open(); }
      else if (e.target.closest('[data-size-guide-close]')) { close(); }
    });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !modal.hidden) close(); });
  }
  // push recently viewed
  try{ window.LI.pushRecent(product.handle); }catch{}
})();

// --- Recently viewed rendering ---
(function(){
  const wrap = document.querySelector('[data-recently-viewed]');
  const grid = document.querySelector('[data-recently-viewed-grid]');
  if(!wrap || !grid) return;
  const handles = (window.LI.recent?.() || []).slice(0,8);
  if(!handles.length) return;
  const money = (cents) => (cents/100).toLocaleString(undefined,{style:'currency',currency:(window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'});
  const sized = (url, w) => url ? url.replace(/(\.(?:jpe?g|png|webp|gif))(\?.*)?$/i, `_${w}x$1$2`) : '';
  Promise.all(handles.map(h => fetch(`/products/${h}.js`).then(r => r.ok ? r.json() : null).catch(()=>null))).then(list => {
    // Only show products that have imagery so the row never renders empty tiles
    const items = list.filter(p => p && p.featured_image).slice(0,4);
    if(!items.length) return;
    wrap.style.display = '';
    grid.innerHTML = items.map(p => {
      const img = p.featured_image;
      const second = (p.images && p.images[1]) || '';
      const onSale = p.compare_at_price && p.compare_at_price > p.price;
      return `
      <article class="product-card">
        <div class="product-card__frame">
          <a class="product-card__media portrait" href="/products/${p.handle}" aria-label="${p.title}">
            <img class="primary" src="${sized(img,600)}" srcset="${sized(img,400)} 400w, ${sized(img,800)} 800w" sizes="(min-width:900px) 25vw, 50vw" alt="${p.title}" loading="lazy" width="600" height="750">
            ${second ? `<img class="secondary" src="${sized(second,600)}" alt="" loading="lazy" width="600" height="750">` : ''}
            <div class="product-card__badges">
              ${onSale ? `<span class="badge badge--sale">Sale${Math.round((p.compare_at_price - p.price) * 100 / p.compare_at_price) > 0 ? ' −' + Math.round((p.compare_at_price - p.price) * 100 / p.compare_at_price) + '%' : ''}</span>` : ''}
              ${p.available === false ? '<span class="badge">Sold out</span>' : ''}
            </div>
          </a>
          <div class="product-card__quick">
            <a class="btn" href="/products/${p.handle}">${p.available === false ? 'Sold out' : 'Choose options'}</a>
          </div>
        </div>
        <div class="product-card__info">
          <div class="product-card__row">
            <div class="product-card__col">
              ${p.type ? `<p class="product-card__cat">${p.type}</p>` : ''}
              <h3 class="product-card__title"><a href="/products/${p.handle}">${p.title}</a></h3>
            </div>
            <div class="product-card__price">
              <span class="price">${money(p.price)}</span>
              ${onSale ? `<span class="price--compare">${money(p.compare_at_price)}</span>` : ''}
            </div>
          </div>
        </div>
      </article>`;
    }).join('');
  });
})();

// --- Fetch product recommendations if section requested ---
(function(){
  const el = document.querySelector('[data-recommendations]');
  if(!el) return;
  fetch(el.dataset.url).then(r=>r.text()).then(html=>{
    const doc = new DOMParser().parseFromString(html,'text/html');
    const sec = doc.querySelector('section, .section') || doc.body;
    el.replaceWith(sec);
  }).catch(()=>{});
})();
